import React from 'react';
import { FormattedMessage } from 'react-intl';

import Heading from 'app/components/layout/Heading.styled';
import { Styled } from 'app/features/newLanding/components/HeroBlock/Perks/Perk.styled';
import Text from 'app/components/layout/Text.styled';

const StreamOnDevices = () => (
  <Styled.Perk data-t="stream-on-device-perk">
    <Styled.PerkIcon viewBox="0 0 24 24" color="pomegranate">
      <path d="M12.05 17.98l.9 2.7A1 1 0 0112 22a1 1 0 01-.95-.68l-.9-2.7a1.85 1.85 0 00-2.33-1.17l-2.7.9a1 1 0 01-.64-1.9l2.7-.9a3.85 3.85 0 014.87 2.43zm9.9-6.3a1 1 0 01-.63 1.27l-2.7.9a1.85 1.85 0 00-1.17 2.33l.9 2.7a1 1 0 01-.95 1.32 1 1 0 01-.95-.68l-.9-2.7a3.85 3.85 0 012.43-4.87l2.7-.9a1 1 0 011.27.63zm-13.5-4.5a3.85 3.85 0 01-2.43 4.87l-2.7.9a1 1 0 01-1.27-.63 1 1 0 01.63-1.27l2.7-.9a1.85 1.85 0 001.17-2.33l-.9-2.7a1 1 0 111.9-.64l.9 2.7zm3.5-1.16l-.9-2.7a1 1 0 01.63-1.27 1 1 0 011.27.63l.9 2.7a1.85 1.85 0 002.33 1.17l2.7-.9a1 1 0 01.64 1.9l-2.7.9a3.83 3.83 0 01-1.22.2 3.85 3.85 0 01-3.65-2.63z" />
    </Styled.PerkIcon>
    <Heading as={Styled.PerkDescription} size="xxs">
      <FormattedMessage id="new_landing_stream_on_multiple_devices" />
    </Heading>
    <Text
      as={Styled.PerkDescriptionMobile}
      size="xl"
      type="semibold"
      isFixedSize
    >
      <FormattedMessage id="new_landing_stream_on_multiple_devices" />
    </Text>
  </Styled.Perk>
);

export default StreamOnDevices;
